import { useLocale } from '@/context/LocaleContext';
import { characterAvatarUrl } from '@/lib/assetUrl';
import type { OnlinePlayer } from '@/hooks/useMessages';

interface OnlinePlayersListProps {
  players: OnlinePlayer[];
  isLoading: boolean;
  search: string;
  onSearchChange: (value: string) => void;
  onSelect: (player: OnlinePlayer) => void;
  loadingLabel: string;
  searchPlaceholder: string;
  title: string;
  onClose: () => void;
}

export function OnlinePlayersModal({
  players,
  isLoading,
  search,
  onSearchChange,
  onSelect,
  loadingLabel,
  searchPlaceholder,
  title,
  onClose,
}: OnlinePlayersListProps) {
  const { t } = useLocale();
  return (
    <dialog id="player-search-modal" className="messages-dialog" aria-label={title} ref={node => {if (node && !node.open) node.showModal();}} onCancel={event => event.preventDefault()}>
      <div className="modal-content">
        <div className="modal-header">
          <h3>{title}</h3>
          <button type="button" className="modal-close" aria-label={t('messages_cancel')} onClick={onClose}>
            ×
          </button>
        </div>
        <div className="modal-body">
          <input
            type="text"
            id="player-search-input"
            className="search-input"
            aria-label={searchPlaceholder}
            placeholder={searchPlaceholder}
            value={search}
            onChange={(e) => onSearchChange(e.target.value)}
          />
          <div className="players-list" id="players-list">
            {isLoading ? (
              <div className="loading-players">{loadingLabel}</div>
            ) : players.length === 0 ? (
              <div className="loading-players">{t('settings_no_results')}</div>
            ) : (
              players.map((player) => (
                <div
                  key={player.CharID}
                  className="player-item"
                  onClick={() => onSelect(player)}
                  onKeyDown={(e) => {if (e.key === 'Enter' || e.key === ' ') {e.preventDefault(); onSelect(player);}}}
                  role="button"
                  tabIndex={0}
                >
                  <img src={characterAvatarUrl(player.RefObjID)} alt="" className="player-avatar" />
                  <span className="player-name">{player.CharName16}</span>
                </div>
              ))
            )}
          </div>
        </div>
      </div>
    </dialog>
  );
}
